var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "POSITION_ANGLE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.6,
    height: 38.8,
    viewBox: "0 0 43.6 38.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #POSITION_ANGLE .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #POSITION_ANGLE .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_411",
    "data-name": "Pfad 411",
    className: "cls-1",
    d: "M29,13.7l-8.6,8.6-.7.7a2.092,2.092,0,0,0-.6-.4l-.9-.3h-.4V9.1h.4a15.615,15.615,0,0,1,10.3,4.1A1.205,1.205,0,0,0,29,13.7Z",
    transform: "translate(0 0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1042",
    "data-name": "Gruppe 1042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_412",
    "data-name": "Pfad 412",
    className: "cls-2",
    d: "M0,9H.8V7.8H1.9V7.1H0Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1585",
    "data-name": "Rechteck 1585",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(18.4 7.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1586",
    "data-name": "Rechteck 1586",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(6.7 7.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1587",
    "data-name": "Rechteck 1587",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(30 7.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1588",
    "data-name": "Rechteck 1588",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(2.8 7.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1589",
    "data-name": "Rechteck 1589",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(26.1 7.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_413",
    "data-name": "Pfad 413",
    className: "cls-2",
    d: "M35,9h.8V7.1H33.9v.7H35Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1590",
    "data-name": "Rechteck 1590",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(35 13.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1591",
    "data-name": "Rechteck 1591",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(35 20.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1592",
    "data-name": "Rechteck 1592",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(35 10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_414",
    "data-name": "Pfad 414",
    className: "cls-2",
    d: "M35,25.1H33.9v.7h1.9V24H35Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1593",
    "data-name": "Rechteck 1593",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(30 25.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1594",
    "data-name": "Rechteck 1594",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(22.2 25.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1595",
    "data-name": "Rechteck 1595",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(2.8 25.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1596",
    "data-name": "Rechteck 1596",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(26.1 25.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1597",
    "data-name": "Rechteck 1597",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(6.7 25.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1598",
    "data-name": "Rechteck 1598",
    className: "cls-2",
    width: 2.9,
    height: 0.8,
    transform: "translate(10.6 25.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_415",
    "data-name": "Pfad 415",
    className: "cls-2",
    d: "M.8,24H0v1.8H1.9v-.7H.8Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1599",
    "data-name": "Rechteck 1599",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(0 17)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1600",
    "data-name": "Rechteck 1600",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1601",
    "data-name": "Rechteck 1601",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(0 20.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1602",
    "data-name": "Rechteck 1602",
    className: "cls-2",
    width: 0.8,
    height: 2.6,
    transform: "translate(0 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_416",
    "data-name": "Pfad 416",
    className: "cls-2",
    d: "M35.9,17.6h0l-.1-.1h0v-.6h-.6l-10-10h0l-7-7-6.9,7-.3.2h-.4v.4h0L4.7,13.4,14.4,23a4.1,4.1,0,0,0-.7,2.2,1.268,1.268,0,0,0,.1.6,4.058,4.058,0,0,0,3.9,3.4,3.408,3.408,0,0,0,2.2-.7L30.2,38.7,43.6,25.2ZM6.1,13.5l5.6-5.6h1.8V7.1H12.4l.2-.1,5.5-5.6L23.7,7l.1.1H22.2v.8h2.4l4.6,4.6-.8.8-8.6,8.6a3.371,3.371,0,0,0-1.7-.5V7.1H14.4v.8h2.7V21.4a4.117,4.117,0,0,0-2.1,1ZM19.3,27.9a2.6,2.6,0,0,1-1.5.4,2.987,2.987,0,0,1-2.9-2.4v-.1c0-.2-.1-.3-.1-.5v-.2a2.836,2.836,0,0,1,.4-1.3c.2-.3.4-.5.6-.8a3.088,3.088,0,0,1,1.4-.7c.2,0,.4-.1.6-.1h.4a1.613,1.613,0,0,1,.9.3,2.092,2.092,0,0,1,.6.4,3.915,3.915,0,0,1,.8,1,3.81,3.81,0,0,1,.3,1v.2a.9.9,0,0,1-.1.5v.1a3.1,3.1,0,0,1-.6,1.3C19.8,27.5,19.6,27.8,19.3,27.9Zm1.5.1a4.208,4.208,0,0,0,1-2c0-.2.1-.4.1-.6a3.606,3.606,0,0,0-.6-2h0l2.6-2.6h3.5V17.3l3.4-3.4,4.3,4.3v1.4h.8v-.7l.1.1,6.4,6.3-12,12.1Z",
    transform: "translate(0 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_417",
    "data-name": "Pfad 417",
    className: "cls-2",
    d: "M19.7,24.8a2.1,2.1,0,0,0-.7-1.1.908.908,0,0,0-.7-.3h-.5a1.268,1.268,0,0,0-.6.1l-.6.3a1.555,1.555,0,0,0-.6.8.9.9,0,0,0-.1.5v.2a.749.749,0,0,0,.1.5v.1a2.044,2.044,0,0,0,1.9,1.4,2.353,2.353,0,0,0,.8-.2,1.555,1.555,0,0,0,.8-.6l.3-.6v-.1a.9.9,0,0,0,.1-.5v-.2C19.7,25,19.7,24.9,19.7,24.8Z",
    transform: "translate(0 0.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionAngle);
export default __webpack_public_path__ + "static/media/position-angle.6528b45d5e340427e53fe68566b0669d.svg";
export { ForwardRef as ReactComponent };